import { createSlice } from '@reduxjs/toolkit';

import {updateSampleCostingDataUi , downloadSampleCostingFile, uploadSampleCostingFile } from '../../apis';

export const sampleCostingPlatform = createSlice({

    name: 'sampleCosting',
    initialState: {
        loading: false,
        error: '',
        receivedIndiaBoxesData: [],
        updateSampleCostingDataUiSuccess: false,
        downloadSampleCostingFileSuccess: false,
        uploadSampleCostingFileSuccess: false,
    },
    reducers: {
        clear: (state, action) => {
            return {
              ...state,
              [action.payload.key]: action.payload.value
            }
          }
    },
    extraReducers: (builder) => {

        builder.addCase(updateSampleCostingDataUi.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(updateSampleCostingDataUi.fulfilled, (state, action) => {
            state.loading = false;
            state.updateSampleCostingDataUiSuccess = true
        })
        builder.addCase(updateSampleCostingDataUi.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(downloadSampleCostingFile.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(downloadSampleCostingFile.fulfilled, (state, action) => {
            state.loading = false;
            state.downloadSampleCostingFileSuccess = true
        })
        builder.addCase(downloadSampleCostingFile.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        builder.addCase(uploadSampleCostingFile.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(uploadSampleCostingFile.fulfilled, (state, action) => {
            state.loading = false;
            state.uploadSampleCostingFileSuccess = true
        })
        builder.addCase(uploadSampleCostingFile.rejected, (state, action) => {
            state.error = action.payload.message
            state.loading = false;
        })
        
    }
})

export const { clear } = sampleCostingPlatform.actions

export default sampleCostingPlatform.reducer